import "./LegalNotice.module.css";
import Header from "@/reusable_sections/Header";
import WhereWeServe from "./sections/WhereWeServe";
import OnsVerhaal from "./sections/OnsVerhaal";
import Footer from "@/reusable_sections/Footer";
export default function LegalNoticePage() {
  return <div>
      <Header />
      <WhereWeServe />
      <OnsVerhaal />
      <Footer />
    </div>;
}